import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Dialog, DialogActions, DialogContent, Typography } from '@guildeducationinc/recess';
import { TrackableButton, useLocale, KEEP_ALIVE, } from 'pe-core-frontend';
import { useAuth } from '@src/hooks/useAuth';
export const LogoutModal = ({ onClose, logoutExpireSec }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const [keepAlive] = useMutation(KEEP_ALIVE);
    const [startTime, setStartTime] = useState(Date.now());
    const [remainingTime, setRemaingTime] = useState(logoutExpireSec);
    const { t } = useLocale();
    const modalTag = 'timeout_logout_modal';
    useEffect(() => {
        setStartTime(Date.now());
        let intId = null;
        intId = setInterval(() => {
            let newRemainingTime = (logoutExpireSec * 1000 - (Date.now() - startTime)) / 1000;
            if (newRemainingTime <= 0) {
                newRemainingTime = 0;
                if (intId)
                    clearInterval(intId);
                logout().then(() => {
                    navigate('/login');
                });
            }
            setRemaingTime(newRemainingTime);
        }, 1000);
        return () => {
            clearInterval(intId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    async function handleCancel() {
        // send keep alive
        await keepAlive();
        onClose();
    }
    async function handleLogout() {
        await logout();
        navigate('/login');
    }
    function TimerMinSec() {
        const minutes = Math.floor(remainingTime / 60);
        const seconds = Math.floor(remainingTime - minutes * 60);
        const mm = `${minutes}`.slice(-2);
        const ss = `0${seconds}`.slice(-2);
        return (_jsxs("div", { children: [_jsx("span", { children: mm }), ":", _jsx("span", { children: ss })] }));
    }
    return (_jsxs(Dialog, { isOpen: true, title: t("You're about to be logged out"), titleSize: 'h2', onClose: handleCancel, fullScreen: true, forceDisableFocusTrap: true, children: [_jsxs(DialogContent, { children: [_jsx(Typography, { variant: 'body2', className: 'mt-2 mb-2', children: t('Time remaining before you are automatically logged out:') }), _jsx(Typography, { variant: 'h2', style: {
                            textAlign: 'center',
                        }, children: _jsx(TimerMinSec, {}) })] }), _jsxs(DialogActions, { fullScreen: false, children: [_jsx(TrackableButton, { enText: 'Log out', tag: `${modalTag}_logout`, appearance: 'outline', onClick: handleLogout, children: t('Log out') }), _jsx(TrackableButton, { enText: 'Stay logged in', tag: `${modalTag}_stay_logged_in`, appearance: 'primary', onClick: handleCancel, children: t('Stay logged in') })] })] }));
};
